import { forwardRef, PropsWithChildren } from 'react';

import clsx from 'clsx';

import { AspectRatio } from '~/shared/components/AspectRatio/AspectRatio';

import styles from './productPickerItem.module.css';

export type ProductPickerItemProps = PropsWithChildren<{
	onClick?: () => void;
	active?: boolean;
	collapsed?: boolean;
	transitioningTo?: boolean;
	transitioningToElsewhere?: boolean;
}>;

export const ProductPickerItem = forwardRef<HTMLDivElement, ProductPickerItemProps>(({ children, onClick, active, collapsed, transitioningTo, transitioningToElsewhere }, forwardedRef) => {
	const ButtonOrDiv = onClick ? 'button' : 'div';

	return (
		<div
			ref={forwardedRef}
			className={clsx(styles.root, {
				[styles.active]: active,
				[styles.collapsed]: collapsed,
				[styles.transitioningTo]: transitioningTo,
				[styles.transitioningToElsewhere]: transitioningToElsewhere,
			})}
		>
			<ButtonOrDiv
				className={styles.button}
				onClick={onClick}
			>
				<AspectRatio ratio={1}>{children}</AspectRatio>
			</ButtonOrDiv>
		</div>
	);
});
